import LicenseDetailsDataRetention from './LicenseDetailsDataRetention';

export default LicenseDetailsDataRetention;
